import { render } from "./Promo.vue?vue&type=template&id=676a1a48"
import script from "./Promo.vue?vue&type=script&lang=js"
export * from "./Promo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Promo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "676a1a48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('676a1a48', __exports__)) {
    api.reload('676a1a48', __exports__)
  }
  
  module.hot.accept("./Promo.vue?vue&type=template&id=676a1a48", () => {
    api.rerender('676a1a48', render)
  })

}


export default __exports__